import { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  getCommentList,
  getCommentListLoading,
  getCommentListError,
  getCommentDetail,
  getCommentDetailLoading,
  getCommentDetailError,
} from '../selectors/comment'
import commentActions from '../actions/comment'

export const useCommentList = () => {
  const commentData = useSelector(getCommentList)
  const loading = useSelector(getCommentListLoading)
  const error = useSelector(getCommentListError)
  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(commentActions, dispatch),
    [],
  )

  return useMemo(
    () => ({
      actions,
      commentData,
      loading,
      error,
    }),
    [actions, commentData, loading, error],
  )
}

export const useCommentDetail = () => {
  const comment = useSelector(getCommentDetail)
  const loading = useSelector(getCommentDetailLoading)
  const error = useSelector(getCommentDetailError)
  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(commentActions, dispatch),
    [dispatch],
  )

  return useMemo(
    () => ({
      actions,
      comment,
      loading,
      error,
    }),
    [actions, comment, loading, error],
  )
}
